import { ProgressBarPercentCell } from "app/components/React/Table/cells/ProgressBarPercentCell";
import getFractionValue from "app/components/React/Table/Utils/getFractionValue";

interface Props {
    value: number | null;
}

const ProgressBarWithProgressiveFraction = ({ value }: Props) => {
    return (
        <ProgressBarPercentCell
            value={value}
            fraction={getFractionValue(value)}
        />
    );
};

export default ProgressBarWithProgressiveFraction;
